module.exports = __webpack_public_path__ + "img/inovled-logo.88a9ea09.png";